
import {
  Component,
  Vue
} from 'vue-property-decorator'
import FdaService from '../services/fda-service'
import TariffService from '../services/tariff-service'
import Currencies from '@/data/currency.json'
import {
  AuthModule
} from '@/store/modules/AuthModule'
import {
  ToastModule
} from '@/store/modules/ToastModule'
import { NotifyModule } from '@/store/modules/NotifyModule'
import {
  Validations
} from 'vuelidate-property-decorators'
import {
  Vuelidate
} from 'vuelidate'
import {
  required
} from 'vuelidate/lib/validators'

@Component({
  name: 'TariffModal'
})
export default class TariffModal extends Vue {
  protected currencies = Currencies
  protected types: any = ['FDA', 'Invoice', 'Refund']
  protected items: any = []
  protected lines: any = []
  protected type: any = null

  $v: Vuelidate

  @Validations()
  validations = {
    lines: {
      $each: {
        item: {
          required
        }
      }
    }
  }

  public show (type) {
    this.type = type
    this.populateTariffDetails()
    this.populateItems();
    (this.$refs.TariffModal as any).show()
  }

  public close () {
    (this.$refs.TariffModal as any).hide()
    this.clear()
  }

  protected populateItems () {
    this.items = []
    FdaService.getServices().then((response) => {
      response.data.forEach((item) => {
        this.items.push({
          value: {
            id: item.id,
            name: item.display_name
          },
          text: item.display_name
        })
      })
    })
  }

  protected populateTariffDetails () {
    TariffService.getTariffDetails(this.type).then((response) => {
      if (response.data.length === 0) this.addLine()

      this.lines = response.data.map((line: any) => ({
        ...line,
        isEdit: false,
        item: {
          id: line.item_id,
          name: line.display_name
        },
        is_formula: line.is_formula === 1
      }))
    })
  }

  protected editLine (lineIndex: number) {
    this.lines[lineIndex].isEdit = !this.lines[lineIndex].isEdit
  }

  protected addLine () {
    this.lines = this.lines.map(line => ({
      ...line,
      isEdit: false
    }))
    this.lines.push({
      id: null,
      isEdit: true,
      item: {},
      type: null,
      description: null,
      quantity: 0,
      rate: 0,
      unit: null,
      currency: 0,
      is_formula: false
    })
  }

  protected clear () {
    this.lines = []
    this.type = null
  }

  protected deleteLine (line, tableIndex) {
    const msg = `Are you sure you want to delete line ${tableIndex + 1}?`
    if (confirm(msg)) {
      if (line.id !== null) {
        TariffService.deleteTriff(line.id)
          .then(response => {
            ToastModule.message(response.data.message)
            this.lines.splice(tableIndex, 1)
          })
          .catch(error => ToastModule.message(error.response.data.message))
      } else this.lines.splice(tableIndex, 1)
    }
  }

  protected save () {
    this.$v.$touch()
    if (this.$v.$invalid) {
      NotifyModule.set('There are fields that require your attention')
      return false
    }

    const lines: any = []
    this.lines.forEach((line) => {
      lines.push({
        ...line,
        item_id: line.item.id,
        created_user: line.id !== null ? line.created_user : AuthModule.user.fullname,
        modified_user: AuthModule.user.fullname
      })
    })

    TariffService.save(lines).then((response) => {
      ToastModule.message(response.data.message)
      this.populateTariffDetails()
    }).catch(error => {
      NotifyModule.set('There was a problem saving your data, Please check and retry again')
      console.log(error)
    })
  }
}
